import { Trash2, Eye, EyeOff } from "lucide-react";
import { formatINR } from "@/lib/quotationApi";

export default function AddedItemsList({ addedItems, updateQty, toggleInclude, removeItem }) {
  if (addedItems.length === 0) return null;
  return (
    <div className="card-luxe mb-4">
      <div className="overline text-white/50 mb-3">Added items</div>
      <div className="space-y-2">
        {addedItems.map((a) => {
          const included = a.is_included !== false;
          return (
            <div
              key={a.id}
              className={`flex items-center justify-between gap-2 p-3 rounded-lg bg-white/[0.02] border transition ${
                included ? "border-white/5" : "border-red-500/20 opacity-60"
              }`}
              data-testid={`accessory-item-${a.id}`}
            >
              <div className="flex-1 min-w-0">
                <div className={`font-medium text-sm truncate flex items-center gap-2 ${included ? "" : "line-through"}`}>
                  {a.name}
                  {a.custom && (
                    <span className="text-[9px] uppercase tracking-wider px-1.5 py-0.5 rounded bg-[#C5A880]/10 text-[#C5A880] border border-[#C5A880]/30">
                      custom
                    </span>
                  )}
                  {!included && (
                    <span className="text-[9px] uppercase tracking-wider text-red-400/80">excluded</span>
                  )}
                </div>
                <div className="text-xs text-white/40">
                  {formatINR(a.price_per_unit)} × {a.quantity} ={" "}
                  <span className="text-[#C5A880]">
                    {formatINR(a.price_per_unit * a.quantity)}
                  </span>
                </div>
              </div>
              <input
                type="number"
                inputMode="numeric"
                value={a.quantity}
                onChange={(e) => updateQty(a.id, e.target.value)}
                className="input-luxe !h-10 !w-16 text-center !px-1"
                data-testid={`accessory-qty-${a.id}`}
              />
              <button
                onClick={() => toggleInclude(a.id)}
                className={`p-2 transition ${included ? "text-[#C5A880]" : "text-white/30 hover:text-white/60"}`}
                data-testid={`accessory-toggle-${a.id}`}
                aria-label={included ? "Exclude" : "Include"}
                title={included ? "Exclude from quotation" : "Include in quotation"}
              >
                {included ? <Eye size={16} /> : <EyeOff size={16} />}
              </button>
              <button
                onClick={() => removeItem(a.id)}
                className="text-white/30 hover:text-red-400 p-2"
                data-testid={`accessory-remove-${a.id}`}
                aria-label="Remove"
              >
                <Trash2 size={16} />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
